export default __webpack_public_path__ + "static/media/IMG_4570-min.f43a092c.JPG";